<template>
  <div class="container">
    <div v-show="loading" class="loading">
      <i  class="fa fa-3x fa-spinner fa-spin"></i>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget-wrap">
          <div class="widget-container margin-top-0">

            <div v-if="orders_loaded && myorders" class="widget-content">
              <div class="row">
                <div class="col-md-12">
                  <div class="w-section-header">
                    <h1>Purchase history</h1>
                    <h1 class="inline hidden">Vendor</h1>
                    <label class="input select hidden">
                      <select v-model="mycompany" @change="getOrders()" class="form-control">
                        <option v-for="(item, index) in companies" v-bind:value="item.id">{{ item.name }}</option>
                      </select>
                      <i></i>
                    </label>
                  </div>
                  <div class="row" v-if="err">
                    <div class="col-xs-12 error-message">
                      {{ err }}
                    </div>
                  </div>  
                  <div class="row" v-if="email">
                    <div class="col-xs-12 success-message">
                      {{ email }}
                    </div>
                  </div>
                  <!-- Trasaction -->                  
                  <div class="row">
                    <div class="col-md-12">                      
                      <div class="row hidden-xs">
                        <div class="col-sm-3 hidden-xs"><h4>Status & Date</h4></div>
                        <div class="col-sm-3"><h4>Purchase ID & Date</h4></div>
                        <div class="col-sm-3 hidden-xs"><h4>Purchase email</h4></div>
                        <div class="col-sm-3 hidden-xs"><h4>Products</h4></div>
                      </div>

                      <div class="panel-group" id="orders">
                        <div class="panel panel-default purchase" v-for="purchase, key in myorders">
                          <div class="row">
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#orders" v-bind:href="'#pur_'+purchase.id" aria-expanded="true" v-bind:aria-controls="'pur_'+purchase.id">

                              <div class="panel-heading btn-primary" role="tab">
                                <h4 class="panel-title">
                                  <div class="row"> 
                                    <div class="col-sm-3 purchase hidden-xs">
                                      <p>
                                        <span v-if="purchase.validated">Purchase confirmed</span>
                                        <span v-if="!purchase.validated">Waiting for confirmation</span><br/>
                                        <small>{{ purchase.last_validate }} GMT</small>
                                      </p>
                                    </div>
                                    <div class="visible-xs-block col-xs-12">
                                      <p>{{ purchase.PurchaseId }}<br/><small>{{ purchase.PurchaseDate }} GMT</small><br/>{{ purchase.BillingContactEmail }}</p>
                                    </div>                                
                                    <div class="col-sm-3 purchase hidden-xs"><p>{{ purchase.PurchaseId }}<br/><small>{{ purchase.PurchaseDate }} GMT</small><span class="visible-xs-block"><br/>{{ purchase.BillingContactEmail }}</span></p></div>
                                    <div class="col-sm-3 purchase hidden-xs"><p>{{ purchase.BillingContactEmail }}</p></div>
                                    <!--<div class="col-xs-6 contact"><p>{{ purchase.BillingContactFirstName }} {{ purchase.BillingContactLastName }}</p></div>-->
                                    <div class="col-sm-3 products hidden-xs"><p>{{ purchase.total_products }}</p></div>                                  
                                  </div>
                                </h4>
                              </div>

                            </a>

                            <div class="panel-collapse collapse" v-bind:id="'pur_'+purchase.id">
                              <div class="panel-body">
                                <div class="inside-me" style="padding-top:15px; padding-bottom:15px; border-bottom:0px;" v-if="purchase.products.length > 0">
                                  <button v-if="!purchase.validated" class="btn btn-sm btn-info" @click="sendEmail(purchase)">Resend confirmation email</button>
                                </div>
                                <div class="inside-me" style="padding-top:15px; padding-bottom:15px;" v-if="purchase.products.length == 0">
                                  <button v-if="!purchase.validated" class="btn btn-sm btn-info" @click="sendEmail(purchase)">Resend confirmation email</button>
                                </div>
                                
                                <span class="visible-xs-block inside-xs">
                                  <p>
                                    <span v-if="purchase.validated">Purchase confirmed</span>
                                    <span v-if="!purchase.validated">Waiting for confirmation</span><br/>
                                    {{ purchase.last_validate }} GMT
                                  </p>                                
                                </span>
                                
                                <table class="table table-striped" v-if="purchase.products.length > 0">
                                  <thead>
                                    <tr role="row">
                                      <th>Product <span class="hidden-xs">name</span></th>
                                      <th>Vers.</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    <tr role="row products" v-for="product, indice in purchase.products">
                                      <td>{{ product.ProductName }}</td>
                                      <td>{{ product.version }}</td>
                                      <!--<td><button class="btn btn-primary" @click="getKeys( key, indice )"> {{ product.keys.length }} <i class="zmdi zmdi-key"></i></button>
                                      </td>
                                      <td><button class="btn btn-primary" @click="getDownload(product)"> <i class="zmdi zmdi-download"></i></button>
                                      </td>-->
                                      <td><button  v-if="!product.parent" class="btn btn-primary" @click="getDownload( indice, product )">Licenses & Downloads</button></td>
                                    </tr>

                                  </tbody>                                  
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <button class="btn btn-default btn-lg" @click="addOrder()" type="button"><i class="zmdi zmdi-collection-plus"></i> Register a new product</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="orders_loaded && !myorders" class="widget-content">
              <div class="row">
                <div class="col-md-12" v-cloak>
                  <p>Ops, no orders.</p>
                  <button class="btn btn-primary" @click="addOrder()">Register now your first product</button>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>            
    </div>
  </div>
</template>

<script>
  import auth from '../auth'
  import client from '../auth/client.js'
  import {router} from '../main'
  //import {loading} from '../main'

  export default {  
    data() {
      return {
        loading: true,
        companies: null,
        mycompany: localStorage.getItem('reseller'),
        myorders:'',
        myproducts:'',
        orders_loaded: false,
        ready: false,
        err: null,
        email: null,
        get utente(){
          return JSON.parse(localStorage.getItem('userdata')) || 0;
        }
      }
    },
   watch: {
      ready: function(val){
        this.loading = true
        if (val == true){
          var user_id = this.utente.id
          if (localStorage.getItem('reseller')==0 || localStorage.getItem('reseller')=='undefined'){
            var company = this.companies[0].id
           
          }else{
            var company = localStorage.getItem('reseller')
          }      
          this.mycompany = company
          if (company){
            auth.getOrders(this, user_id, company)
            auth.getCatalog(this, user_id, company)
            auth.getCanbuy(this)
          }
        }
      },
      orders_loaded: function(val){
        if (this.myorders.length == 0){
          /* se non ho prodotti registrato redirect su ADD-ORDER */
          router.push('/add-order');
        }
      }
    },
    methods: {
      getOrders(){
        this.loading = true
        var user_id = this.utente.id
        if (this.mycompany){
          auth.getOrders(this, user_id, this.mycompany)
        }        
      },
      getKeys(orderIndex, productIndex){
        var mykeys = this.myorders[orderIndex].products[productIndex].keys
        auth.getKeys(this, mykeys)
      },
      getProdKeys(productIndex){
        var mykeys = this.myproducts[productIndex].keys
        auth.getKeys(this, mykeys)
      },      
      getDownload(productIndex, item){
        var mykeys = this.myproducts[productIndex].keys
        auth.getDownload(this, item.id, item)
        //auth.getKeys(this, mykeys, item)
      },
      addOrder(){
        router.push('/add-order');
      },
      sendEmail(item){
        auth.sendEmail(this, item.token, item.company, item.user)
      }
    },
    created(){
      this.loading = true
      this.companies = auth.getCompany(this)
      console.log(this.companies)
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Transactions.vue